// extracted by mini-css-extract-plugin
export default {"container":"ImageTags_container__Lm-vw","addTags":"ImageTags_addTags__X1HYx","create":"ImageTags_create__gotDQ"};